import { Stack, Box } from "@compono/ui";
import {
  color1,
  color2,
  color3,
  color4,
  color5,
} from "../../../components/BarStackChart/BarStackChart";
import { calculatePercentage } from "../../../components/BarStackChart/utils";
import { RESPONSE_BAND_LABELS } from "../engagementCopy";

export const buildHoverContent = (
  item: { value: any; color?: string; label: any },
  total: number,
  includeResponses = true,
) => {
  return (
    <Stack>
      <Box>
        {Math.round(calculatePercentage(item.value, total) * 10) / 10}%{" "}
        {item.label.toLowerCase()}
      </Box>
      {includeResponses && (
        <Box>
          {item.value} {item.value > 1 ? "responses" : "response"}
        </Box>
      )}
    </Stack>
  );
};

/**
 * Counts one answer into the bands it is given, by indexing them with the answer itself — so the
 * caller has to have ruled out anything that is not one of the five before it gets here.
 *
 * Typed to the answer rather than to `never`, which is what it took while its only caller passed a
 * value inferred from an untyped array.
 */
export const buildItems = (
  items: { value: number; color: string; label: string }[],
  answer: number,
) => {
  const before = items[answer - 1].value;
  items[answer - 1].value = before + 1;
  return items;
};

const BAND_COLORS = [color1, color2, color3, color4, color5];

/**
 * The five answers a climate question offers, all at zero, ready for `buildItems` to count into.
 *
 * A fresh array every call, because `buildItems` counts by mutating the one it is given — a shared
 * constant would have every bar on the page accumulating into the same five numbers.
 */
export const emptyBands = () =>
  RESPONSE_BAND_LABELS.map((label, band) => ({
    value: 0,
    color: BAND_COLORS[band],
    label: label as string,
  }));
